import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import type {SmtpTestResultStatus} from '../types/SmtpTestResultStatus';

export function isSmtpTestResultStatus(status: string): status is SmtpTestResultStatus {
  return [
    smtpCredentialsTestStatus.done,
    smtpCredentialsTestStatus.failed,
    smtpCredentialsTestStatus.warning,
    smtpCredentialsTestStatus.skip,
  ].some((result) => result === status);
}
